var moduleCodes = require('./moduleCodes');

module.exports = {
  [moduleCodes.MODULE_RA]: "ra",
  [moduleCodes.MODULE_ADMIN]: "admin",
  [moduleCodes.MODULE_INSPECTION_COACH]: "inspection-coach",
  [moduleCodes.MODULE_INSPECTION_CENTRE]: "improvement-hub",
  [moduleCodes.MODULE_2BAP]: "2bap",

  customModulePath: 'module',

	getModulePathList() {
  	return [
  		this[moduleCodes.MODULE_RA],
  		this[moduleCodes.MODULE_ADMIN],
  		this[moduleCodes.MODULE_INSPECTION_COACH],
		this[moduleCodes.MODULE_INSPECTION_CENTRE],
		this[moduleCodes.MODULE_2BAP]
		]
	},

	getModulePathListString() {
  	return this.getModulePathList().join('|');
	},

  createCustomModulePath(moduleCode) {
    return `/${this.customModulePath}?id=${moduleCode}`
  },

  getModulePath(module) {
    if (module.isCustom) {
      return this.createCustomModulePath(module.code);
    }
    return this[module.code];
  }

};
